/**
 * System Statistics Service (Admin)
 *
 * Provides methods to fetch system-wide statistics and metrics
 */

import api from '../api';
import type { SystemStats } from '../../types/admin';

/**
 * Get comprehensive system statistics
 *
 * Returns:
 * - User statistics (total, roles, verification rate)
 * - Account statistics (total, by plan)
 * - Campaign statistics (total, active, paused)
 * - Request statistics (total, recent, bot rate)
 * - Trends (daily requests)
 * - Top campaigns by request count
 */
export async function getSystemStats(): Promise<SystemStats> {
  const response = await api.get<SystemStats>('/api/admin/stats');
  return response.data;
}

/**
 * System stats service object
 */
export const systemStatsService = {
  getSystemStats,
};
